export default __webpack_public_path__ + "static/media/google-play-logo.0866d271.svg";